import { formatPrice } from "../../common/utils";

const filterKeys = [
  "q",
  "product_type",
  "vendor",
  "meta.custom.search_color",
  "meta.custom.search_size",
  "price_min",
  "price_max",
  "meta.custom.sales_type",
  "meta.custom.detail_sleeve",
  "meta.custom.detail_length",
  "detail_length_min",
  "detail_length_max",
  "meta.custom.detail_silhouette",
  "inventory_available",
  "page",
  "sort_type",
  "collections",
];

const shouldAlgoliasearchKeys = [
  "q",
  "product_type",
  "vendor",
  "meta.custom.search_color",
  "meta.custom.search_size",
  "price_min",
  "price_max",
  "meta.custom.sales_type",
  "meta.custom.detail_sleeve",
  "meta.custom.detail_length",
  "detail_length_min",
  "detail_length_max",
  "meta.custom.detail_silhouette",
  "collections",
];

const filterParamsWithSearchParams = (searchParams) => {
  const filterParams = [];
  for (const key of filterKeys) {
    for (const [k, v] of searchParams.entries()) {
      if (key == k) {
        filterParams.push({ key: k, value: v });
      }
    }
  }
  return updateSortType(filterParams);
};

const createFromCurrentLocation = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return filterParamsWithSearchParams(searchParams);
};

const generateSearchParams = (filterParams) => {
  const searchParams = new URLSearchParams();
  filterParams.forEach((fp) => searchParams.append(fp.key, fp.value));

  const currentSearchParams = new URLSearchParams(window.location.search);
  for (const [k, v] of currentSearchParams.entries()) {
    if (!filterKeys.includes(k)) {
      searchParams.append(k, v);
    }
  }
  return searchParams;
};

const pushHistory = (filterParams) => {
  const searchParams = generateSearchParams(filterParams);
  const strSearch = searchParams.toString();
  const path = `${window.location.pathname}${0 < strSearch.length ? "?" : ""}${strSearch}`;
  history.pushState({}, "", path);
};

const splitQueries = (q, sectionParams) => {
  const tags = [];
  const qs = [];

  q.split(/\s+/).forEach((part) => {
    if (part.startsWith("#")) {
      tags.push(`tags:${part.substring(1)}`);
    } else {
      qs.push(part);
    }
  });

  return {
    q: qs.join(" "),
    facetFilters: tags,
  };
};

const createAlgoliasearchParams = (filterParams, sectionParams) => {
  let page = 1;
  let sort_type = "published_at_desc";
  let q = "";
  const filters = [];
  const facetFilters = [];
  const numericFilters = [];

  filterParams.filter((kv) => kv.key == "page").forEach((kv) => (page = parseInt(kv.value)));
  filterParams.filter((kv) => kv.key == "sort_type").forEach((kv) => (sort_type = kv.value));
  filterParams.filter((kv) => kv.key == "q").forEach((kv) => (q = kv.value));

  const queries = splitQueries(q, sectionParams);
  q = queries.q;
  if (0 < queries.facetFilters.length) {
    facetFilters.push(queries.facetFilters);
  }

  filterParams
    .filter((kv) => kv.key == "inventory_available")
    .forEach((kv) => {
      if (kv.value == "true") {
        filters.push("variants_inventory_count > 0");
      }
    });

  const facetFilterKeys = [
    "product_type",
    "vendor",
    "meta.custom.search_color",
    "meta.custom.search_size",
    "meta.custom.sales_type",
    "meta.custom.detail_sleeve",
    "meta.custom.detail_length",
    "meta.custom.detail_silhouette",
    "collections",
  ];
  facetFilterKeys.forEach((k) => {
    const params = filterParams.filter((kv) => kv.key == k).map((kv) => `${kv.key}:${kv.value}`);
    if (0 < params.length) {
      facetFilters.push(params);
    }
  });
  facetFilters.push(["product_type:-OPTION"]);

  if (sectionParams.collection.handle == "familysale2025") {
    facetFilters.push([`collections:${sectionParams.collection.handle}`]);
  } else if (sectionParams.collection.handle != "all") {
    facetFilters.push([`vendor:${sectionParams.collection.title}`]);
  }

  facetFilters.push([`tags:-outlet`]);

  const priceMin = filterParams.find((kv) => kv.key == "price_min");
  if (priceMin) {
    numericFilters.push(`price>=${priceMin.value}`);
  }
  const priceMax = filterParams.find((kv) => kv.key == "price_max");
  if (priceMax) {
    numericFilters.push(`price<=${priceMax.value}`);
  }

  const detailLengthMin = filterParams.find((kv) => kv.key == "detail_length_min");
  if (detailLengthMin) {
    numericFilters.push(`meta.custom.detail_length_cm>=${detailLengthMin.value}`);
  }
  const detailLengthMax = filterParams.find((kv) => kv.key == "detail_length_max");
  if (detailLengthMax) {
    numericFilters.push(`meta.custom.detail_length_cm<=${detailLengthMax.value}`);
  }

  return {
    page: page,
    sort_type: sort_type,
    q: q,
    filters: filters,
    facetFilters: facetFilters,
    numericFilters: numericFilters,
  };
};

const currentSortType = (filterParams, sectionParams) => {
  const kv = filterParams.find((kv) => kv.key == "sort_type");
  if (kv) {
    return kv.value;
  }
  return sectionParams.sort_type;
};

const currentPage = (filterParams) => {
  const kv = filterParams.find((kv) => kv.key == "page");
  if (kv) {
    return parseInt(kv.value);
  }
  return 1;
};

const inventoryAvailable = (filterParams) => {
  const kv = filterParams.find((kv) => kv.key == "inventory_available");
  if (kv && kv.value == "true") {
    return true;
  }
  return false;
};

const updateSortType = (newFilterParams) => {
  if (newFilterParams.findIndex((kv) => shouldAlgoliasearchKeys.includes(kv.key)) < 0) {
    return newFilterParams;
  }
  const kv = newFilterParams.find((kv) => kv.key == "sort_type");
  if (!kv) {
    newFilterParams.push({ key: "sort_type", value: "published_at_desc" });
  }
  return newFilterParams;
};

const removePageParamsIfNeed = (filterParams, newFilterParams) => {
  let removePage = false;
  const currentKeys = filterParams.filter((kv) => kv.key != "page").map((kv) => kv.key);
  const newKeys = newFilterParams.filter((kv) => kv.key != "page").map((kv) => kv.key);
  if (currentKeys.length != newKeys.length) {
    removePage = true;
  } else {
    for (const currentKey of currentKeys) {
      const currentFP = filterParams.find((fp) => fp.key == currentKey);
      const newFP = newFilterParams.find((fp) => fp.key == currentKey);
      if (!currentFP || !newFP || currentFP.value != newFP.value) {
        removePage = true;
        break;
      }
    }
  }
  if (removePage) {
    newFilterParams = newFilterParams.filter((kv) => kv.key != "page");
  }

  return newFilterParams;
};

const headerDetailText = (filterParams, sectionParams) => {
  let menuTitle = null;
  let menuFilterParams = null;

  if (sectionParams.keyword_menu) {
    for (const { title, url } of sectionParams.keyword_menu) {
      const searchParams = new URLSearchParams(new URL(url).search);
      const menuFp = filterParamsWithSearchParams(searchParams);

      let result = -1;
      for (const { key, value } of menuFp) {
        result = filterParams.findIndex((kv) => {
          if (key == "q" && kv.key == key) {
            const menuValues = value.split(/\s+/);
            const values = kv.value.split(/\s+/);
            for (const q of menuValues) {
              if (!values.includes(q)) {
                return false;
              }
            }
            return true;
          }
          if (kv.key == key && kv.value == value) {
            return true;
          }
          return false;
        });
        if (result < 0) {
          break;
        }
      }
      if (0 <= result) {
        menuTitle = title;
        menuFilterParams = menuFp;
        break;
      }
    }
  }

  let details = [];

  if (menuTitle) {
    details.push(`#${menuTitle}`);
  }
  const qkv = filterParams.find((kv) => kv.key == "q");
  if (qkv) {
    details = details.concat(qkv.value.split(/\s+/));
  }

  const categoryList = sectionParams.category_list;
  const collectionTitles = filterParams
    .filter((kv) => kv.key == "collections")
    .map((kv) => {
      const title = categoryList
        .map((categoryItem) => {
          if (kv.value == categoryItem.handle) {
            return categoryItem.title;
          }
          const childItem = categoryItem.items.find((ci) => kv.value == ci.handle);
          if (childItem) {
            return childItem.title;
          }
          return "";
        })
        .find((title) => 0 < title.length);
      if (0 < title.length) {
        return title;
      }
      return kv.value;
    });
  details = details.concat(collectionTitles);

  const keys0 = ["product_type", "vendor", "meta.custom.search_color", "meta.custom.search_size"];
  details = details.concat(filterParams.filter((kv) => keys0.includes(kv.key)).map((kv) => kv.value));

  const min = filterParams.find((kv) => kv.key == "price_min");
  const minText = min ? formatPrice(parseInt(min.value)) : "";
  const max = filterParams.find((kv) => kv.key == "price_max");
  const maxText = max ? formatPrice(parseInt(max.value)) : "";
  if (min || max) {
    details.push(`${minText}〜${maxText}`);
  }

  const keys1 = ["meta.custom.sales_type", "meta.custom.detail_sleeve", "meta.custom.detail_length"];
  details = details.concat(filterParams.filter((kv) => keys1.includes(kv.key)).map((kv) => kv.value));

  const lengthMin = filterParams.find((kv) => kv.key == "detail_length_min");
  const lengthMinText = lengthMin ? `${lengthMin.value}cm` : "";
  const lengthMax = filterParams.find((kv) => kv.key == "detail_length_max");
  const lengthMaxText = lengthMax ? `${lengthMax.value}cm` : "";
  if (lengthMin || lengthMax) {
    details.push(`着丈${lengthMinText}〜${lengthMaxText}`);
  }

  const keys2 = ["meta.custom.detail_silhouette"];
  details = details.concat(filterParams.filter((kv) => keys2.includes(kv.key)).map((kv) => kv.value));

  const inventoryAvailableKv = filterParams.find((kv) => kv.key == "inventory_available");
  if (inventoryAvailableKv && inventoryAvailableKv.value == "true") {
    details.push("在庫あり");
  }

  let detailText = details.slice(0, 5).join(", ");
  if (5 < details.length) {
    detailText = detailText + ", ...";
  }
  return detailText;
};

const duplicate = (filterParams) => {
  return filterParams.map((kv) => {
    return { key: kv.key, value: kv.value };
  });
};

const FilterParamsUtil = {
  filterKeys: filterKeys,
  shouldAlgoliasearchKeys: shouldAlgoliasearchKeys,
  createFromCurrentLocation: createFromCurrentLocation,
  generateSearchParams: generateSearchParams,
  pushHistory: pushHistory,
  createAlgoliasearchParams: createAlgoliasearchParams,
  currentSortType: currentSortType,
  currentPage: currentPage,
  inventoryAvailable: inventoryAvailable,
  updateSortType: updateSortType,
  removePageParamsIfNeed: removePageParamsIfNeed,
  headerDetailText: headerDetailText,
  duplicate: duplicate,
};

export default FilterParamsUtil;
